import { useEffect, RefObject } from 'react';
import { getFieldErrors } from '../utils/apiError';

interface FormRefCurrent {
  submitForm: () => void;
  setValues: (values: Record<string, unknown>) => void;
  setErrors: (errors: unknown) => void;
}

interface FormError {
  response?: {
    data?: unknown;
  };
}

function useFormRutine(
  formRef: RefObject<FormRefCurrent>,
  submitOutside: boolean,
  reset: boolean,
  formProps: Record<string, unknown>,
  resetConfirm: () => void,
  error: FormError | null
): void {
  useEffect(() => {
    let isSubscribed = true;

    if (isSubscribed && submitOutside) {
      formRef.current?.submitForm();
    }

    return () => {
      isSubscribed = false;
    };
  }, [submitOutside]);

  useEffect(() => {
    if (reset === true) {
      formRef.current?.setValues(formProps);
      resetConfirm();
    }
  }, [reset]);

  useEffect(() => {
    formRef.current?.setErrors(getFieldErrors(error));
  }, [error]);
}

export default useFormRutine;
